import { useRef } from "react";
import Input from "../../components/Input";
import Select from "../../components/Select";

import Table1 from "./Table1";
import Table2 from "./Table2";

const HomeBottom = ({ approvedPending, rejected, change }) => {
	const formElement = useRef();

	const handleUpdate = (name, value) => {
		if (name === "name") {
			formElement.current.night.selectedIndex = 0;
			formElement.current.status.selectedIndex = 0;
			formElement.current.hotel.selectedIndex = 0;
		} else if (name === "night") {
			formElement.current.name.value = "";
			formElement.current.status.selectedIndex = 0;
			formElement.current.hotel.selectedIndex = 0;
		} else if (name === "status") {
			formElement.current.name.value = "";
			formElement.current.night.selectedIndex = 0;
			formElement.current.hotel.selectedIndex = 0;
		} else if (name === "hotel") {
			formElement.current.name.value = "";
			formElement.current.night.selectedIndex = 0;
			formElement.current.status.selectedIndex = 0;
		}
		change(name, value);
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
	};

	return (
		<>
			<form
				ref={formElement}
				method="post"
				action="/"
				onSubmit={(e) => handleSubmit(e)}
				className="well"
				style={{
					marginTop: "0",
					marginBottom: "15px",
					paddingTop: "10px",
				}}
			>
				<h4
					style={{
						marginTop: "0",
						lineHeight: "22px",
						marginBottom: "5px",
						fontSize: "1.1rem",
					}}
				>
					Filter Hotel Reservations by Criteria
				</h4>

				<p style={{ marginTop: "0" }}>
					Use any of the following fields to sort your requests below or use the
					buttons to add a new one.
				</p>

				<div className="form-group four">
					<Input
						name="name"
						label="Occupant Name (partial"
						reqd={false}
						value={""}
						autocomplete="off"
						update={handleUpdate}
						errors={[]}
					/>

					<Select
						name="night"
						label="Night"
						reqd={false}
						value={""}
						options={[
							{ id: "", name: "--" },
							{ id: "sun1", name: "Sunday, March 29th" },
							{ id: "mon1", name: "Monday, March 30th" },
							{ id: "tue1", name: "Tuesday, March 31st" },
							{ id: "wed1", name: "Wednesday, April 1st" },
							{ id: "thu1", name: "Thursday, April 2nd" },
							{ id: "fri1", name: "Friday, April 3rd" },
							{ id: "sat1", name: "Saturday, April 4th" },
							{ id: "sun2", name: "Sunday, April 5th" },
							{ id: "mon2", name: "Monday, April 6th" },
						]}
						update={handleUpdate}
						error={false}
					/>

					<Select
						name="status"
						label="Status"
						reqd={false}
						value={""}
						options={[
							{ id: "", name: "--" },
							{ id: "1", name: "Approved" },
							{ id: "2", name: "Pending" },
							{ id: "0", name: "Unavailable" },
						]}
						update={handleUpdate}
						error={false}
					/>

					<Select
						name="hotel"
						label="Hotel"
						reqd={false}
						value={""}
						options={[
							{ id: "", name: "--" },
							{ id: "JW Marriott", name: "JW Marriott" },
						]}
						update={handleUpdate}
						error={false}
					/>
				</div>
			</form>
			<Table1
				type="approved-pending"
				text="Approved & Pending Requests"
				data={approvedPending}
			/>
			<Table2 type="rejected" text="Unavailable Requests" data={rejected} />
		</>
	);
};

export default HomeBottom;
